import { AfterViewInit, Component, Renderer2, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Event, NavigationEnd } from '@angular/router';
import { SpecimenPreviewService } from '../../../service/specimen-preview.service';
import { GoogleTagManagerService } from '../../../service/googleTagManagerService.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'app-view-image',
    templateUrl: './view-image.component.html',
    styleUrls: ['./view-image.component.scss'],
})
export class ViewImageComponent implements AfterViewInit, OnInit {
    data: any;
    specimens: [];
    kitNumber: string;
    @ViewChild('lightbox') lightbox;

    imageLightboxData = [];
    defaultLightboxImageData = {
        id: '',
        imageIndex: 0,
        imageUrl: '',
        lightboxPageNumber: 1,
        title: '',
        fullsizeUrl: '',
        fullsizeS3Url: ''
    };
    selectedLightboxImage = this.defaultLightboxImageData;
    selectedLightboxImageIndex = 0;
    public columnArray = [1, 2, 3, 4, 5, 6];

    constructor(private renderer: Renderer2,
        private specimenPreviewservice: SpecimenPreviewService,
        private route: ActivatedRoute,
        private router: Router,
        private domSanitizer: DomSanitizer,
        private googleTagManagerService: GoogleTagManagerService) {
        this.googleTagManagerService.addGtmToDom();
    }

    ngOnInit(): void {


        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                const gtmTag = {
                    "event": 'View Image Page',
                    "cap.ui.pagePath": event.url,
                    "cap.ui.pageTitle": event.url
                };

                this.googleTagManagerService.pushTag(gtmTag);
            }
        });

        this.route.paramMap.subscribe(params => {
            this.kitNumber = params.get('kitNumber');
            this.specimenPreviewservice.getImages(this.kitNumber).subscribe(res => {
            if(res && res.fileList && res.fileList.length>0){

                res.fileList.forEach( item => {
                    this.specimenPreviewservice.getImageS3Url(item.url).subscribe(res_url => {
                        item.url = res_url;
                    });
                    const ext = item.name.split('.').pop();
                    if (ext == 'zip') {
                        item['isZip'] = true
                    }
                    if (ext == 'htm' || ext == 'html') {
                        item['isHTML'] = true;
                    }
                });

            }


                this.data = res;
                this.getImageLightboxData(this.data);
            });
        });
    }

    ngAfterViewInit() {
        // THIS IS INTENTIONAL
    }

    getSenitizeURL = (url) => {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }

    onClickUrl(url) {
        return url.split('&_gl')[0];
    }
    
    getImageLightboxData(data) {
        // LIGHTBOXINDEXPAGENUMBERCTR IS USED TO DISPLAY THE PAGE NUMBER ON THE LIGHTBOX
        let lightboxIndexPageNumberCtr = 1;
        let caseData = (data.cases) ? data.cases : [];
        let SpecimenData = (data.specimens) ? data.specimens : [];
        let caseSpecimenData = (caseData.length > 0) ? caseData : SpecimenData;
        caseSpecimenData.forEach(specimen => {
            specimen.images.forEach(image => {
                this.imageLightboxData.push({
                    id: image.imageId,
                    imageIndex: image.imageIndex,
                    lightboxPageNumber: lightboxIndexPageNumberCtr,
                    imageUrl: image.thumbnailPreSignedUrl,
                    title: image.imageLabel,
                    fullsizeUrl: image.fullsizeUrl
                });

                lightboxIndexPageNumberCtr++;
            })
        });
    }
    // CALLING FUNCTION TO OPEN IMAGE LIGHT BOX ON CLICK EVENT.
    openImageLightbox(selectedImageId) {
        this.renderer.addClass(this.lightbox.nativeElement, 'open');
        this.renderer.addClass(document.body, 'lightbox-open');
        this.selectedLightboxImage = this.imageLightboxData.filter(imageLightboxItem => {
            return imageLightboxItem.id === selectedImageId;
        })[0];

        this.specimenPreviewservice.getImageS3Url(this.selectedLightboxImage.fullsizeUrl).subscribe(res => {
            this.selectedLightboxImage.fullsizeS3Url = res;
        });

        this.selectedLightboxImageIndex = this.selectedLightboxImage.imageIndex;
    }
    // TO CLOSE LIGHT BOX IMAGE WINDOW.
    closeImageLightbox() {
        this.renderer.removeClass(this.lightbox.nativeElement, 'open');
        this.renderer.removeClass(document.body, 'lightbox-open');
        this.selectedLightboxImage = this.defaultLightboxImageData;
    }

    lightboxImageNavigate(direction) {
        // LEFT ARROW CLICKED
        if (direction === -1 && this.selectedLightboxImageIndex !== 1) {
            this.selectedLightboxImageIndex += direction;
            this.selectedLightboxImage = this.imageLightboxData.filter(imageLightboxItem => {
                return imageLightboxItem.imageIndex === this.selectedLightboxImageIndex;
            })[0];
        }
        // RIGHT ARROW CLICKED
        if (direction === 1 && this.selectedLightboxImageIndex !== this.imageLightboxData.length) {
            this.selectedLightboxImageIndex += direction;
            this.selectedLightboxImage = this.imageLightboxData.filter(imageLightboxItem => {
                return imageLightboxItem.imageIndex === this.selectedLightboxImageIndex;
            })[0];
        }
    }
    // TO SHOW AND HIDE INTERPRETIVE MENU.
    toggleInterpretiveMenu(event) {
        const interpretiveMenuLink = event.target;
        const linkOpenClassName = 'open';

        if (interpretiveMenuLink.classList.contains(linkOpenClassName)) {
            this.renderer.removeClass(interpretiveMenuLink, linkOpenClassName);
        } else {
            this.renderer.addClass(interpretiveMenuLink, linkOpenClassName);
        }
    }
    // TO DISPLAY IMAGE LABEL TYPE.
    displayImageLabelType(imageObj) {
        let resLabelString = "Image";

        if (imageObj.imageLabel && imageObj.imageLabel != "") {
            resLabelString = imageObj.imageLabel;
        } else if (imageObj.docTypeDesc && imageObj.docTypeDesc != "" &&
            imageObj.docSubTypeDesc && imageObj.docSubTypeDesc != "") {
            resLabelString = `${imageObj.docTypeDesc} - ${imageObj.docSubTypeDesc}`;
        } else if (imageObj.docTypeDesc && imageObj.docTypeDesc != "") {
            resLabelString = imageObj.docTypeDesc;
        } else if (imageObj.docSubTypeDesc && imageObj.docSubTypeDesc != "") {
            resLabelString = imageObj.docSubTypeDesc;
        }
        return resLabelString;
    }
}
